import React from 'react';
import { Briefcase, BookOpen } from 'react-feather';
import { CREDENTIAL_TYPE } from 'app/constants/profile';

const ProfileCredentialIcon = props => {
  const { credentialType } = props;

  if (credentialType === CREDENTIAL_TYPE.EDUCATION) {
    return (
      <BookOpen
        size={18}
        className="mr-2 text-neutral-500 min-h-[18px] min-w-[18px]"
      />
    );
  }
  if (credentialType === CREDENTIAL_TYPE.EMPLOYMENT) {
    return (
      <Briefcase
        size={18}
        className="mr-2  text-neutral-500 min-h-[18px] min-w-[18px]"
      />
    );
  }
  return null;
};

export default ProfileCredentialIcon;
